export default __webpack_public_path__ + "static/media/job.931a5750.jpg";